
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';

import {LodgementPeriod} from '../models/LodgementPeriod'
import {ClaimModel} from '../models/ClaimModel'
import {ClaimList} from '../models/ClaimList'
import {ClaimPayload} from '../models/ClaimPayload'
import {ClaimDocument} from '../models/ClaimDocument'
import {GrantHistory} from '../models/GrantHistory'
import {ClaimSubmission} from '../models/ClaimSubmission'
import {SubmissionDTO} from '../models/SubmissionDTO'
import {BSB} from '../models/BSB'
import {ClaimYear} from '../models/ClaimYear'

export class ClaimController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/claim');
    }
    
        getLodgementPeriods(owner:ISupportSpinner, year:number, periodType:number, success:{(res:LodgementPeriod[]):any}, error?:AjaxError) {
    super._call('get', 'GetLodgementPeriods', owner, {year:year,periodType:periodType}, null, success, error)
}

        prepopulate(owner:ISupportSpinner, model:ClaimModel, success:{(res:ClaimModel):any}, error?:AjaxError) {
    super._call('post', 'prepopulate', owner, null, model, success, error)
}

        getList(owner:ISupportSpinner, success:{(res:ClaimList):any}, error?:AjaxError) {
    super._call('get', 'search', owner, null, null, success, error)
}

        create(owner:ISupportSpinner, year:string, success:{(res:string):any}, error?:AjaxError) {
    super._call('post', '', owner, {year:year}, null, success, error, 'text')
}

        updateClaim(owner:ISupportSpinner, model:ClaimModel, success:{():any}, error?:AjaxError) {
    super._call('put', 'UpdateClaim', owner, null, model, success, error, 'text')
}

        updateSchedules(owner:ISupportSpinner, model:ClaimModel, scheduleType:number, success:{():any}, error?:AjaxError) {
    super._call('put', 'UpdateSchedules', owner, {scheduleType:scheduleType}, model, success, error, 'text')
}

        updateRelationships(owner:ISupportSpinner, model:ClaimModel, success:{():any}, error?:AjaxError) {
    super._call('put', 'UpdateRelationships', owner, null, model, success, error, 'text')
}

        updateMarketShare(owner:ISupportSpinner, model:ClaimModel, success:{():any}, error?:AjaxError) {
    super._call('put', 'UpdateMarketShare', owner, null, model, success, error, 'text')
}

        getItem(owner:ISupportSpinner, id:string, success:{(res:ClaimPayload):any}, error?:AjaxError) {
    super._call('get', '', owner, {id:id}, null, success, error)
}

        getDocuments(owner:ISupportSpinner, claimId:string, success:{(res:ClaimDocument[]):any}, error?:AjaxError) {
    super._call('get', 'documents', owner, {claimId:claimId}, null, success, error)
}

        downloadCompletedApplication(owner:ISupportSpinner, claimId:string, success:{():any}, error?:AjaxError) {
    super._call('get', 'downloadCompletedApplication', owner, {claimId:claimId}, null, success, error)
}

        getGrantHistory(owner:ISupportSpinner, abn:string, success:{(res:GrantHistory[]):any}, error?:AjaxError) {
    super._call('get', 'grantHistory', owner, {abn:abn}, null, success, error)
}

        submit(owner:ISupportSpinner, submission:ClaimSubmission, success:{(res:SubmissionDTO):any}, error?:AjaxError) {
    super._call('put', 'submit', owner, null, submission, success, error)
}

        bsbSearch(owner:ISupportSpinner, searchTxt:string, success:{(res:BSB):any}, error?:AjaxError) {
    super._call('get', 'bsbsearch', owner, {searchTxt:searchTxt}, null, success, error)
}

        deactivateClaim(owner:ISupportSpinner, claimId:string, success:{(res:boolean):any}, error?:AjaxError) {
    super._call('get', 'RemoveClaim', owner, {claimId:claimId}, null, success, error)
}

        getYears(owner:ISupportSpinner, type:number, success:{(res:ClaimYear[]):any}, error?:AjaxError) {
    super._call('get', '', owner, {type:type}, null, success, error)
}
}
